// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2U7Mo","navText":"Navbar_navText__GReiW","navLogo":"Navbar_navLogo__3HQOW","imgLogo":"Navbar_imgLogo__1GTZb"};